export interface RepeatDataUpdate {
  lookbackWindow: number;
  fullNameFallback: boolean;
}

export const exampleRepeatDataUpdate: RepeatDataUpdate = {
  lookbackWindow: 91,
  fullNameFallback: true,
};
